import React from 'react';
import './Contact.css';
import ContactForm from '../../components/contactForm/ContactForm';
import ContactIntro from '../../components/contactIntro/ContactIntro';

export default class Contact extends React.Component {
  render() {
    return (
      <section className="contact"> 
        <ContactIntro/>
        <ContactForm/>
      </section>
    )
  }
}